<!-- 搜索汽配件 -->
<template>
    <div class="searchAp-ctn" v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-row">
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.JointSearch.IsShow">{{
                            searchShowSets.JointSearch.Title }}</div>
                        <el-input v-if="searchShowSets.JointSearch.IsShow" class="search-item" size="small" ref="searchapf"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.APCode.IsShow">{{ searchShowSets.APCode.Title }}</div>
                        <el-input v-if="searchShowSets.APCode.IsShow" class="search-item" size="small"
                            v-model="searchData.APCode" :placeholder="searchShowSets.APCode.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodName.IsShow">{{ searchShowSets.GoodName.Title }}
                        </div>
                        <el-input v-if="searchShowSets.GoodName.IsShow" class="search-item" size="small"
                            v-model.trim="searchData.GoodName" :placeholder="searchShowSets.GoodName.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.AutoSerise.IsShow">{{ searchShowSets.AutoSerise.Title
                        }}</div>
                        <el-input class="search-item" size="small" v-if="searchShowSets.AutoSerise.IsShow"
                            v-model.trim="searchData.AutoSerise" :placeholder="searchShowSets.AutoSerise.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodCode.IsShow">{{ searchShowSets.GoodCode.Title }}
                        </div>
                        <el-input class="search-item" size="small" v-if="searchShowSets.GoodCode.IsShow"
                            v-model.trim="searchData.GoodCode" :placeholder="searchShowSets.GoodCode.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Cate.IsShow">{{ searchShowSets.Cate.Title }}</div>
                        <div class="search-item goods-categories" v-if="searchShowSets.Cate.IsShow">
                            <el-select size="small" style="width: 100%" v-model="searchData.Cate" multiple collapse-tags
                                filterable clearable @visible-change="getGoodsType($event)"
                                @keyup.enter.native="handleSearch">
                                <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text"
                                    :value="optionItem.Value">
                                    <div class="option-content">
                                        <div>{{ optionItem.Text }}</div>
                                    </div>
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.BrandId.IsShow">{{ searchShowSets.BrandId.Title }}
                        </div>
                        <div class="search-item goods-categories" v-if="searchShowSets.BrandId.IsShow">
                            <el-select v-model="searchData.BrandName" multiple collapse-tags filterable clearable
                                size="small" style="width: 100%" @visible-change="getGoodsBrand($event)"
                                @keyup.enter.native="handleSearch">
                                <el-option :key="item.Text" v-for="item in brandList" :label="item.Text"
                                    :value="item.Text"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Origin.IsShow">{{ searchShowSets.Origin.Title }}
                        </div>
                        <el-input class="search-item" size="small" v-if="searchShowSets.Origin.IsShow"
                            v-model.trim="searchData.Origin" :placeholder="searchShowSets.Origin.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>                    
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Invent.IsShow">{{ searchShowSets.Invent.Title }}</div>
                        <el-select v-if="searchShowSets.Invent.IsShow" size="small" class="search-item" style="width: 90px"
                            v-model="searchData.Symbol" clearable :placeholder="searchShowSets.Invent.Placeholder"
                            @keyup.enter.native="handleSearch">
                            <el-option key=">=" label=">=" value=">="></el-option>
                            <el-option key=">" label=">" value=">"></el-option>
                            <el-option key="<=" label="<=" value="<="></el-option>
                            <el-option key="<" label="<" value="<"></el-option>
                            <el-option key="=" label="=" value="="></el-option>
                            <el-option key="!=" label="!=" value="!="></el-option>
                            <el-option key="between" label="区间" value="between"></el-option>
                        </el-select>
                        <el-input v-if="searchShowSets.Invent.IsShow" class="search-item" size="small" style="width: 90px"
                            v-model.trim="searchData.Invent1" @keyup.enter.native="handleSearch"></el-input>
                        <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2"
                            @keyup.enter.native="handleSearch"
                            v-if="searchData.Symbol == 'between' && searchShowSets.Invent.IsShow"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Size.IsShow">{{ searchShowSets.Size.Title }}</div>
                        <el-input v-if="searchShowSets.Size.IsShow" class="search-item" size="small"
                            v-model.trim="searchData.Size" :placeholder="searchShowSets.Size.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodDesc.IsShow">{{ searchShowSets.GoodDesc.Title }}
                        </div>
                        <el-input v-if="searchShowSets.GoodDesc.IsShow" class="search-item" size="small"
                            v-model.trim="searchData.GoodDesc" :placeholder="searchShowSets.GoodDesc.Placeholder"
                            @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <div class="flex" v-if="searchShowSets.SalesDate.IsShow">
                        <div class="search-name">{{ searchShowSets.SalesDate.Title }}</div>
                        <el-date-picker v-model="dateTimes" type="datetimerange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions" @change="handleChange" size="small" class="search-name"
                            format="yyyy-MM-dd HH:mm" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
                    </div>
                    <el-button size="small" class="search-btn btn-primary" @click="selectCarType">精准车型 (选中{{
                        searchData.SeriseSelected.length }}项)</el-button>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                        @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary"
                        @click="resetSearch">重置</el-button>
                    <el-button v-if="canEdit != 'canNot'" size="small" icon="el-icon-plus" class="search-btn btn-primary"
                        @click="showAddAPDialog">新增配件</el-button>
                    <el-button v-if="!OnlyOneOption" class="search-btn btn-primary" size="small" @click="chooseAPs()">确定
                        (选中{{ selection.length }}项)</el-button>
                    <el-button v-if="!OnlyOneOption && isSearch" class="search-btn btn-primary" size="small"
                        @click="chooseAllAPs()">确定 (筛选结果{{ tableDataLength }}项)</el-button>
                    <el-button size="small" icon="el-icon-setting" type="primary" class="search-btn"
                        @click="showSearchSetDialog()">搜索设置</el-button>
                    <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn"
                        @click="showTableSetDialog()">表格设置</el-button>
                </div>
            </div>
        </div>
        <div class="dialog-search-table-ctn search-table-i">
            <el-table ref="dialogTable" :data="tableData" :header-cell-style="{ background: '#F2F6FC' }" border=""
                height="500px" style="width: 100%; margin-bottom: 5px" @selection-change="onColumnSelect"
                @sort-change="sortChange" @row-click="rowClick" @cell-dblclick="dblChooseAps"
                v-el-table-infinite-scroll="tableLoad" :row-key="getRowKeys" highlight-current-row>
                <el-table-column type="selection" width="55" reserve-selection v-if="!OnlyOneOption"
                    fixed="left"></el-table-column>
                <el-table-column v-if="columnShowSets.APCode.IsShow" width="180px" :label="columnShowSets.APCode.ColumnName"
                    prop="APCode" sortable="custom" show-overflow-tooltip fixed="left">
                    <template slot-scope="scope">
                        <span class="sp-i">
                            <i v-if="scope.row.MainImage" class="el-icon-picture"
                                @click.stop="showAPMsgDialog(scope.row.EntpTempGoodsId)"></i>
                            <i v-else class="el-icon-info" @click.stop="showAPMsgDialog(scope.row.EntpTempGoodsId)"></i>
                        </span>
                        <span>{{ scope.row.APCode }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.GoodCode.IsShow"
                    :width="columnShowSets.GoodCode.Width > 0 ? columnShowSets.GoodCode.Width + 'px' : '160px'"
                    :label="columnShowSets.GoodCode.ColumnName" prop="GoodCode" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.GoodName.IsShow"
                    :width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '160px'"
                    :label="columnShowSets.GoodName.ColumnName" prop="GoodName" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.AutoSerise.IsShow"
                    :width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '200px'"
                    :label="columnShowSets.AutoSerise.ColumnName" prop="AutoSerise" sortable="custom">
                    <template slot-scope="scope">
                        <el-tooltip placement="top">
                            <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(scope.row.AutoSerise)"></div>
                            <div class="tooltip-div">{{ scope.row.AutoSerise }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.GeneralModels.IsShow"
                    :width="columnShowSets.GeneralModels.Width > 0 ? columnShowSets.GeneralModels.Width + 'px' : '200px'"
                    :label="columnShowSets.GeneralModels.ColumnName" prop="GeneralModels" sortable="custom">
                    <template slot-scope="scope">
                        <el-tooltip placement="top">
                            <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(scope.row.GeneralModels)">
                            </div>
                            <div class="tooltip-div">{{ scope.row.GeneralModels }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.Cate.IsShow"
                    :width="columnShowSets.Cate.Width > 0 ? columnShowSets.Cate.Width + 'px' : '110px'"
                    :label="columnShowSets.Cate.ColumnName" prop="Cate" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Brand.IsShow"
                    :width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '110px'"
                    :label="columnShowSets.Brand.ColumnName" prop="Brand" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Unit.IsShow"
                    :width="columnShowSets.Unit.Width > 0 ? columnShowSets.Unit.Width + 'px' : '60px'"
                    :label="columnShowSets.Unit.ColumnName" prop="Unit" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Inventory.IsShow"
                    :width="columnShowSets.Inventory.Width > 0 ? columnShowSets.Inventory.Width + 'px' : '80px'"
                    :label="columnShowSets.Inventory.ColumnName" prop="Inventory" sortable="custom" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ StorageId ? scope.row.StorageInventory : scope.row.Inventory }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.Remaining.IsShow"
                    :width="columnShowSets.Remaining.Width > 0 ? columnShowSets.Remaining.Width + 'px' : '80px'"
                    :label="columnShowSets.Remaining.ColumnName" prop="Remaining" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            {{
                                (StorageId ? scope.row.StorageInventory : scope.row.Inventory) + (isAddWaitIn ?
                                    scope.row.POrderWaitInQuantity : 0) - scope.row.OrderWaitOutQuantity
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.SalesOutWHCout.IsShow"
                    :width="columnShowSets.SalesOutWHCout.Width > 0 ? columnShowSets.SalesOutWHCout.Width + 'px' : '90px'"
                    :label="columnShowSets.SalesOutWHCout.ColumnName" prop="SalesOutWHCout" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.OrderWaitOutQuantity.IsShow"
                    :width="columnShowSets.OrderWaitOutQuantity.Width > 0 ? columnShowSets.OrderWaitOutQuantity.Width + 'px' : '80px'"
                    :label="columnShowSets.OrderWaitOutQuantity.ColumnName" prop="OrderWaitOutQuantity"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="showNeedOutData(scope.row)" type="text" style="padding: 0px"
                            v-if="scope.row.OrderWaitOutQuantity > 0">{{
                                scope.row.OrderWaitOutQuantity
                            }}</el-button>
                        <span v-else>{{ scope.row.OrderWaitOutQuantity }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.POrderWaitInQuantity.IsShow"
                    :width="columnShowSets.POrderWaitInQuantity.Width > 0 ? columnShowSets.POrderWaitInQuantity.Width + 'px' : '80px'"
                    :label="columnShowSets.POrderWaitInQuantity.ColumnName" prop="POrderWaitInQuantity"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="showNeedInData(scope.row)" type="text" style="padding: 0px"
                            v-if="scope.row.POrderWaitInQuantity > 0">{{
                                scope.row.POrderWaitInQuantity
                            }}</el-button>
                        <span v-else>{{ scope.row.POrderWaitInQuantity }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.UpperLimit.IsShow"
                    :width="columnShowSets.UpperLimit.Width > 0 ? columnShowSets.UpperLimit.Width + 'px' : '80px'"
                    :label="columnShowSets.UpperLimit.ColumnName" prop="UpperLimit" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.LowerLimit.IsShow"
                    :width="columnShowSets.LowerLimit.Width > 0 ? columnShowSets.LowerLimit.Width + 'px' : '80px'"
                    :label="columnShowSets.LowerLimit.ColumnName" prop="LowerLimit" show-overflow-tooltip></el-table-column>
                <el-table-column prop="PlanPurchase" key="PlanPurchase" sortable="custom"
                    v-if="columnShowSets.PlanPurchase.IsShow"
                    :width="columnShowSets.PlanPurchase.Width > 0 ? columnShowSets.PlanPurchase.Width + 'px' : '100px'"
                    :label="columnShowSets.PlanPurchase.ColumnName" resizable header-align></el-table-column>
                <el-table-column prop="IntenCount" key="IntenCount" v-if="columnShowSets.IntenCount.IsShow"
                    :width="columnShowSets.IntenCount.Width > 0 ? columnShowSets.IntenCount.Width + 'px' : '80px'"
                    :label="columnShowSets.IntenCount.ColumnName" resizable header-align>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.IntenCount > 0" @click="showIntentDatas(scope.row.EntpTempGoodsId)"
                            type="text" style="padding: 0px">{{
                                scope.row.IntenCount
                            }}</el-button>
                        <span v-else>{{ scope.row.IntenCount }}</span>
                    </template></el-table-column>
                <el-table-column v-if="columnShowSets.CostPrice.IsShow"
                    :width="columnShowSets.CostPrice.Width > 0 ? columnShowSets.CostPrice.Width + 'px' : '110px'"
                    :label="columnShowSets.CostPrice.ColumnName" prop="CostPrice" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Price.IsShow"
                    :width="columnShowSets.Price.Width > 0 ? columnShowSets.Price.Width + 'px' : '110px'"
                    :label="columnShowSets.Price.ColumnName" prop="Price" sortable="custom"
                    show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.MarketPrice.IsShow"
                    :width="columnShowSets.MarketPrice.Width > 0 ? columnShowSets.MarketPrice.Width + 'px' : '110px'"
                    :label="columnShowSets.MarketPrice.ColumnName" prop="MarketPrice" sortable="custom"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{
                            Source != 0
                            ? scope.row.MarketPrice
                            : priceType == 0
                                ? scope.row.MarketPrice
                                : priceType == 1
                                    ? calcType == 1
                                        ? Math.round(scope.row.CostPrice * pricePoint)
                                        : calcType == 2
                                            ? Math.ceil(scope.row.CostPrice * pricePoint)
                                            : calcType == 3
                                                ? Math.floor(scope.row.CostPrice * pricePoint)
                                                : (scope.row.CostPrice * pricePoint).toFixed(2)
                                    : priceType == 2
                                        ? calcType == 1
                                            ? Math.round(scope.row.Price * pricePoint)
                                            : calcType == 2
                                                ? Math.ceil(scope.row.Price * pricePoint)
                                                : calcType == 3
                                                    ? Math.floor(scope.row.Price * pricePoint)
                                                    : (scope.row.Price * pricePoint).toFixed(2)
                                        : priceType == 3
                                            ? calcType == 1
                                                ? Math.round(scope.row.MarketPrice * pricePoint)
                                                : calcType == 2
                                                    ? Math.ceil(scope.row.MarketPrice * pricePoint)
                                                    : calcType == 3
                                                        ? Math.floor(scope.row.MarketPrice * pricePoint)
                                                        : (scope.row.MarketPrice * pricePoint).toFixed(2)
                                            : scope.row.MarketPrice
                        }}
                    </template>
                </el-table-column>
                <el-table-column v-if="columnShowSets.Origin.IsShow"
                    :width="columnShowSets.Origin.Width > 0 ? columnShowSets.Origin.Width + 'px' : '120px'"
                    :label="columnShowSets.Origin.ColumnName" prop="Origin" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Quality" sortable="custom" v-if="columnShowSets.Quality.IsShow"
                    :width="columnShowSets.Quality.Width > 0 ? columnShowSets.Quality.Width + 'px' : '80px'"
                    :label="columnShowSets.Quality.ColumnName" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Size.IsShow"
                    :width="columnShowSets.Size.Width > 0 ? columnShowSets.Size.Width + 'px' : '140px'"
                    :label="columnShowSets.Size.ColumnName" prop="Size" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="columnShowSets.Size2.IsShow"
                    :width="columnShowSets.Size2.Width > 0 ? columnShowSets.Size2.Width + 'px' : '140px'"
                    :label="columnShowSets.Size2.ColumnName" prop="Size2" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Texture" v-if="columnShowSets.Texture.IsShow"
                    :width="columnShowSets.Texture.Width > 0 ? columnShowSets.Texture.Width + 'px' : '100px'"
                    :label="columnShowSets.Texture.ColumnName" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Color" v-if="columnShowSets.Color.IsShow"
                    :width="columnShowSets.Color.Width > 0 ? columnShowSets.Color.Width + 'px' : '100px'"
                    :label="columnShowSets.Color.ColumnName" show-overflow-tooltip></el-table-column>
                <el-table-column prop="GoodDesc" v-if="columnShowSets.GoodDesc.IsShow"
                    :width="columnShowSets.GoodDesc.Width > 0 ? columnShowSets.GoodDesc.Width + 'px' : '200px'"
                    :label="columnShowSets.GoodDesc.ColumnName" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateTime" sortable="custom" v-if="columnShowSets.CreateTime.IsShow"
                    :width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                    :label="columnShowSets.CreateTime.ColumnName" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="OnlyOneOption" fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button class="btn-primary" label="选中" size="mini" style="padding: 5px 12px"
                                @click="chooseAP(scope.row)">选中</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-else fixed="right" label="进销历史" width="160">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <img src="@/assets/images/sup.png" label="采购历史" style="width: 26px; height: 26px"
                                @click="showHistories(scope.row.EntpTempGoodsId)" />
                            <!-- <img src="@/assets/images/supreturn.png" label="采购退货历史"
                                style="width: 26px; height: 26px; margin-left: 2px"
                                @click="showReHistories(scope.row.EntpTempGoodsId)" /> -->
                            <img src="@/assets/images/cus.png" style="width: 25px; height: 25px; margin-left: 2px"
                                label="销售历史" @click="showSaleStat(scope.row)" />
                            <!-- <img src="@/assets/images/cusreturn.png" style="width: 24px; height: 24px; margin-left: 2px"
                                label="销售退货历史" @click="showSaleReStat(scope.row)" /> -->
                            <img src="@/assets/images/analysis.png" style="width: 23px; height: 23px; margin-left: 4px"
                                label="数据分析" @click="analysis(scope.row)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--    新增库存    -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" @closeDialog="closeAddAPDialog">
        </transInventory>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible"
            append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible"
            append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets :tableCode="'SearchAP'" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" append-to-body v-dialog-drag
            lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div v-if="historyVisible">
                <APPurchaseHistory ref="APPurchaseHistory" :EntpTempGoodsId="hisGoodsId" :Source="Number(Source)"
                    :EntpCusId="Source == 1 ? EntpCusId : ''" :EntpCusName="Source == 1 ? EntpCusName : ''" :NoInit="true"
                    @closeDialog="() => {
                            historyVisible = false;
                        }
                        "></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div v-if="eyeHistoryVisible">
                <APHistory ref="APHistory" :showCusColumn="Source == 0" :EntpCusId="Source == 0 ? EntpCusId : ''"
                    :EntpCusName="Source == 0 ? EntpCusName : ''" :EntpTempGoodsId="hisGoodsId" :NoInit="true"
                    @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="采购退货历史" :visible.sync="historyReVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div v-if="historyReVisible">
                <APPurReturnHistory ref="APPurReturnHistory" :EntpTempGoodsId="hisGoodsId" :Source="Number(Source)"
                    :EntpCusId="Source == 1 ? EntpCusId : ''" :EntpCusName="Source == 1 ? EntpCusName : ''" :NoInit="true"
                    @closeDialog="() => {
                            historyReVisible = false;
                        }
                        "></APPurReturnHistory>
            </div>
        </el-dialog>
        <!-- 销售退货历史 -->
        <el-dialog :title="SaleReDialogTitle" :close-on-click-modal="false" :visible.sync="eyeReHistoryVisible"
            append-to-body v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div v-if="eyeReHistoryVisible">
                <APSaleReturnHistory ref="APSaleReturnHistory" :showCusColumn="Source == 0"
                    :EntpCusId="Source == 0 ? EntpCusId : ''" :EntpCusName="Source == 0 ? EntpCusName : ''"
                    :EntpTempGoodsId="hisGoodsId" :NoInit="true" @closeDialog="eyeReHistoryVisible = false">
                </APSaleReturnHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis ref="goodsAnalysis" :GoodsId="hisGoodsId" :NoInit="true"
                    @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <!-- 数量、单价预填写 -->
        <el-dialog :close-on-click-modal="false" title="加入清单" :visible.sync="rowVisible" append-to-body v-dialog-drag
            lock-scroll :modal="false" id="change-dialog" custom-class="add-row-dialog" style="margin-left: -170px">
            <div class="form-div">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input-number :min="1" :precision="0" controls-position="right" v-model="rowForm._count" />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input-number :min="0" :precision="2" controls-position="right" v-model="rowForm._price" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm">提交</el-button>
                <el-button size="small" @click="rowClose">取消</el-button>
            </div>
        </el-dialog>
        <!--    车型选择    -->
        <el-dialog title="选择车系" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1380px" append-to-body>
            <selectSeries :visible="dialogVisible" @confirmButton="confirmSeriesButton" />
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="询价历史" :visible.sync="inqHistoryVisible" append-to-body v-dialog-drag
            lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px">
            <div v-if="inqHistoryVisible">
                <APInquiryHistory ref="APInquiryHistory" :EntpTempGoodsId="hisGoodsId" :Source="1" @closeDialog="() => {
                        inqHistoryVisible = false;
                    }
                    "></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog :title="NeedITitle" :close-on-click-modal="false" :visible.sync="needInDataVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px" width="900px">
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId"
                    @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog :title="NeedOTitle" :close-on-click-modal="false" :visible.sync="needOutDataVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px" width="900px">
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId"
                    @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog title="配件信息" :close-on-click-modal="false" :visible.sync="APMsgVisible" append-to-body v-dialog-drag
            lock-scroll :modal="false" id="change-dialog" style="margin-left: -500px" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg ref="APMsg" :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" :edit="false"
                    @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import transInventory from '@/components/business/search/transInventory';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import tableSets from '@/components/common/tableSets.vue';
import searchSets from '@/components/common/searchSets.vue';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import selectSeries from '@/components/business/goods/selectSeries';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APPurReturnHistory from '@/components/common/APPurReturnHistory';
import APSaleReturnHistory from '@/components/common/APSaleReturnHistory';
import APMsg from '@/components/common/APMsg';
export default {
    name: '',
    props: [
        'EntpCusId',
        'EntpCusName',
        'canEdit',
        'OnlyOneOption',
        'StorageId',
        'IsGetNoSets',
        'IsOnlySets',
        'Source', //来源，0表示该组件用于销售单(1采购)编辑页面，来表示是否要判断仓位的类型；不需要的功能不必添加该属性
        'SelectedData', //已经选择了的数据，需要被过滤的数据
        'dragType', // 弹框类型：1 表示从开单页进入
        'dragSign', // 弹框标识
        'isMultiSup', //是否来自多供应商采购
        'priceType',
        'pricePoint',
        'calcType'
    ],
    components: {
        transInventory,
        tableSets,
        searchSets,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis,
        selectSeries,
        APInquiryHistory,
        APNeedInDatas,
        APNeedOutDatas,
        APMsg,
        APPurReturnHistory,
        APSaleReturnHistory
    },
    data() {
        return {
            isCanTBSet: false,
            tableSetsVisible: false,
            searchSetVisible: false,
            addAPVisible: false,
            historyVisible: false,
            historyReVisible: false,
            eyeHistoryVisible: false,
            eyeReHistoryVisible: false,
            goodsAnalysisVisible: false,
            inqHistoryVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            SaleDialogTitle: '',
            SaleReDialogTitle: '',
            hisGoodsId: '', //查看销售或采购历史的配件id
            loading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            dialogVisible: false,
            isSearch: false,
            // tableCode: 'SearchAP',
            tableCode: 'DialogSearchAP',
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 20,
                CId: this.EntpCusId,
                SId: this.StorageId,
                SortProp: '',
                SortType: '',
                IsGetNoSets: false,
                IsOnlySets: false,
                Source: '',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                SelectedData: [],
                SeriseSelected: [],
                InStartDate: '',
                InEndDate: '',
                Origin:''
            },
            searchParams: {}, //这个才是真正请求列表接口的条件，当页面等于1的时候重新取searchData的值，searchData目前用来绑定控件数据
            tableData: [],
            tableDataLength: 0,
            selection: [],
            stopFresh: false,
            columnShowSets: {
                APCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodName: { ColumnName: '', IsShow: false, Width: 0 },
                AutoSerise: { ColumnName: '', IsShow: false, Width: 0 },
                GeneralModels: { ColumnName: '', IsShow: false, Width: 0 },
                CostPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Price: { ColumnName: '', IsShow: false, Width: 0 },
                MarketPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Inventory: { ColumnName: '', IsShow: false, Width: 0 },
                Remaining: { Remaining: '', IsShow: false, Width: 0 },
                SalesOutWHCout: { ColumnName: '', IsShow: false, Width: 0 },
                OrderWaitOutQuantity: { ColumnName: '', IsShow: false, Width: 0 },
                POrderWaitInQuantity: { ColumnName: '', IsShow: false, Width: 0 },
                UpperLimit: { ColumnName: '', IsShow: false, Width: 0 },
                LowerLimit: { ColumnName: '', IsShow: false, Width: 0 },
                Unit: { ColumnName: '', IsShow: false, Width: 0 },
                Cate: { ColumnName: '', IsShow: false, Width: 0 },
                Brand: { ColumnName: '', IsShow: false, Width: 0 },
                Origin: { ColumnName: '', IsShow: false, Width: 0 },
                Quality: { ColumnName: '', IsShow: false, Width: 0 },
                Size: { ColumnName: '', IsShow: false, Width: 0 },
                Size2: { ColumnName: '', IsShow: false, Width: 0 },
                Texture: { ColumnName: '', IsShow: false, Width: 0 },
                Color: { ColumnName: '', IsShow: false, Width: 0 },
                GoodDesc: { ColumnName: '', IsShow: false, Width: 0 },
                UpdateTime: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 },
                PlanPurchase: { ColumnName: '', IsShow: false, Width: 0 },
                IntenCount: { ColumnName: '', IsShow: false, Width: 0 }
            },
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                BrandId: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                GoodDesc: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Invent: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                SalesDate: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Origin: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
            },
            separator: '',
            isAddWaitIn: true,
            // 新增行内容
            rowVisible: false,
            rowForm: {},
            dateTimes: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            APMsgVisible: false,
            isStartSearch: false
        };
    },
    watch: {
        tableData() {
            this.doLayout();
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.searchapf.focus();
                });
            }
        }
    },
    created() {
        this.getConfigByCodes();
        if (this.tableCode) {
            this.getSetsData();
            this.getSearchCrtSetsData();
            this.getJointSearchSets();
        }
    },
    mounted() {
        if (this.IsGetNoSets) this.searchData.IsGetNoSets = this.IsGetNoSets;
        if (this.IsOnlySets) this.searchData.IsOnlySets = this.IsOnlySets;
        this.searchData.Source = this.Source;
        // this.getTableData();
        // 打开时禁止页面滚动
        document.body.style = 'overflow:hidden';
    },
    destroyed() {
        document.body.style = 'overflow:auto';
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        // 单击一行，更新所有弹框内容
        rowClick(row) {
            if (this.historyVisible) {
                this.$refs.APPurchaseHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.eyeHistoryVisible) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.historyReVisible) {
                this.$refs.APPurReturnHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.eyeReHistoryVisible) {
                this.SaleReDialogTitle = '销售退货数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.$refs.APSaleReturnHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.goodsAnalysisVisible) {
                this.$refs.goodsAnalysis.updateTableData(row.EntpTempGoodsId);
            }
            if (this.rowVisible) {
                this.dblChooseAps(row);
            }
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad() {
            if (!this.stopFresh) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        // 选择配件
        chooseAP(item) {
            this.$emit('closeDialog', item);
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        chooseAllAPs() {
            if (this.tableDataLength == 0) return;
            this.searchData.limit = this.tableDataLength;
            this.searchData.page = 1;
            this.tableData = [];

            this.$emit('chooseAllAPsHandle', {
                searchData: this.searchData
            });
        },
        rowConfirm() {
            let index = this.tableData.findIndex(e => e.EntpTempGoodsId == this.rowForm.EntpTempGoodsId);
            if (index > -1) {
                this.tableData.splice(index, 1);
                this.searchData.SelectedData.push(this.rowForm.EntpTempGoodsId);
            }

            this.$emit('closeDialog', [this.rowForm], true);
            this.rowVisible = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.rowForm = {};
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            if ([e][0] && this.dragType * 1 === 1) {
                let _price = 0;
                // 针对不同的开单页，赋予不同的价格
                if (this.dragSign === 'supplierRFQEdit') {
                    // _price = e.Price;
                    _price = e.LatestPurPrice ? e.LatestPurPrice : e.CostPrice;
                } else if (this.dragSign === 'transToSupplierOrder') {
                    // _price = e.CostPrice;
                    _price = e.LatestPurPrice ? e.LatestPurPrice : e.CostPrice;
                } else if (['bjEdit', 'salesOrderEdit'].includes(this.dragSign)) {
                    _price = e.LatestPrice;
                }
                this.rowVisible = true;
                this.rowForm = {
                    ...[e][0],
                    _count: 1,
                    _price
                };
            } else {
                this.$emit('closeDialog', [e]);
            }
        },
        showAddAPDialog() {
            this.addAPVisible = true;
        },
        showSearchSetDialog() {
            this.searchSetVisible = true;
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closeAddAPDialog() {
            this.addAPVisible = false;
        },
        closeDialog(isEdit) {
            if(this.tableSetsVisible == true){
                this.tableSetsVisible = false;
                this.$router.go(0)
            }
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        //采购历史
        showHistories(id) {
            if (id) {
                this.hisGoodsId = id;
                this.historyVisible = true;
            }
        },
        showReHistories(id) {
            if (id) {
                this.hisGoodsId = id;
                this.historyReVisible = true;
            }
        },
        // 历史销售
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.hisGoodsId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        showSaleReStat(row) {
            if (row) {
                this.SaleReDialogTitle = '销售退货数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.hisGoodsId = row.EntpTempGoodsId;
                this.eyeReHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.hisGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => { });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => { });
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Size: '',
                CId: this.EntpCusId,
                Brand: '',
                BrandName: [],
                Cate: [],
                page: 1,
                limit: 20,
                SId: this.StorageId,
                SortProp: '',
                SortType: '',
                IsGetNoSets: this.IsGetNoSets,
                IsOnlySets: this.IsOnlySets,
                Source: this.Source,
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                SelectedData: [],
                SeriseSelected: [],
                InStartDate: '',
                InEndDate: '',
                Origin:''
            };
            this.dateTimes = [];
            this.isSearch = false;
        },
        getTableData() {
            return new Promise(resolve => {
                if (this.searchData.Symbol) {
                    if (this.searchData.Symbol == 'between') {
                        if (isNaN(this.searchData.Invent1)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                        if (isNaN(this.searchData.Invent2)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    } else {
                        if (isNaN(this.searchData.Invent1)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    }
                }
                if (this.SelectedData && this.SelectedData.length > 0) {
                    this.searchData.SelectedData = this.SelectedData;
                }
                if (this.searchData.page == 1) {
                    this.searchParams = { ...this.searchData };
                } else {
                    this.searchParams.page = this.searchData.page;
                }
                this.loading = true;
                this.stopFresh = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetGoodsListForOrder',
                        // data: this.searchData,
                        data: this.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        this.tableDataLength = res.count;
                        if (!data) {
                            if (this.searchData.page == 1) this.tableData = [];
                            return;
                        }

                        let list = [...this.tableData, ...data];
                        const maps = new Map();
                        list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                        //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                        this.tableData = list;
                        this.stopFresh = data.length < this.searchData.limit;

                        resolve(this.tableData);

                        this.getOtherData(data);
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData(id) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetAfterSearchPartData',
                    data: {
                        GoodsId: id,
                        CId: that.EntpCusId,
                        SId: that.StorageId,
                        Source: that.Source,
                        IsMultiSup: that.isMultiSup
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            // item.StorageInventory = data.StorageInventory;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.LatestPrice = data.LatestPrice;
                            item.LatestSalesTime = data.LatestSalesTime;
                            item.Supplier = data.Supplier;
                            if (data.ReferencePrice) item.ReferencePrice = data.ReferencePrice;
                            else item.ReferencePrice = item.MarketPrice;
                            return;
                        }
                    });
                })
                .catch(() => { });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.tableData = [];
            this.$refs.dialogTable.clearSelection();
            this.isSearch = true;
            // 防止多次点击
            if (!this.loading) {
                this.scrollTop = 0;
                this.scrollLeft = 0;
                this.getTableData();
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodCode':
                            this.columnShowSets.GoodCode.IsShow = item.IsShow;
                            this.columnShowSets.GoodCode.Width = item.Width;
                            this.columnShowSets.GoodCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'GeneralModels':
                            this.columnShowSets.GeneralModels.IsShow = item.IsShow;
                            this.columnShowSets.GeneralModels.Width = item.Width;
                            this.columnShowSets.GeneralModels.ColumnName = item.ColumnName;
                            break;
                        case 'CostPrice':
                            this.columnShowSets.CostPrice.IsShow = item.IsShow;
                            this.columnShowSets.CostPrice.Width = item.Width;
                            this.columnShowSets.CostPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Price':
                            this.columnShowSets.Price.IsShow = item.IsShow;
                            this.columnShowSets.Price.Width = item.Width;
                            this.columnShowSets.Price.ColumnName = item.ColumnName;
                            break;
                        case 'MarketPrice':
                            this.columnShowSets.MarketPrice.IsShow = item.IsShow;
                            this.columnShowSets.MarketPrice.Width = item.Width;
                            this.columnShowSets.MarketPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Inventory':
                            this.columnShowSets.Inventory.IsShow = item.IsShow;
                            this.columnShowSets.Inventory.Width = item.Width;
                            this.columnShowSets.Inventory.ColumnName = item.ColumnName;
                            break;
                        case 'Remaining':
                            this.columnShowSets.Remaining.IsShow = item.IsShow;
                            this.columnShowSets.Remaining.Width = item.Width;
                            this.columnShowSets.Remaining.ColumnName = item.ColumnName;
                            break;
                        case 'SalesOutWHCout':
                            this.columnShowSets.SalesOutWHCout.IsShow = item.IsShow;
                            this.columnShowSets.SalesOutWHCout.Width = item.Width;
                            this.columnShowSets.SalesOutWHCout.ColumnName = item.ColumnName;
                            break;
                        case 'OrderWaitOutQuantity':
                            this.columnShowSets.OrderWaitOutQuantity.IsShow = item.IsShow;
                            this.columnShowSets.OrderWaitOutQuantity.Width = item.Width;
                            this.columnShowSets.OrderWaitOutQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'POrderWaitInQuantity':
                            this.columnShowSets.POrderWaitInQuantity.IsShow = item.IsShow;
                            this.columnShowSets.POrderWaitInQuantity.Width = item.Width;
                            this.columnShowSets.POrderWaitInQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'UpperLimit':
                            this.columnShowSets.UpperLimit.IsShow = item.IsShow;
                            this.columnShowSets.UpperLimit.Width = item.Width;
                            this.columnShowSets.UpperLimit.ColumnName = item.ColumnName;
                            break;
                        case 'LowerLimit':
                            this.columnShowSets.LowerLimit.IsShow = item.IsShow;
                            this.columnShowSets.LowerLimit.Width = item.Width;
                            this.columnShowSets.LowerLimit.ColumnName = item.ColumnName;
                            break;
                        case 'Unit':
                            this.columnShowSets.Unit.IsShow = item.IsShow;
                            this.columnShowSets.Unit.Width = item.Width;
                            this.columnShowSets.Unit.ColumnName = item.ColumnName;
                            break;
                        case 'Cate':
                            this.columnShowSets.Cate.IsShow = item.IsShow;
                            this.columnShowSets.Cate.Width = item.Width;
                            this.columnShowSets.Cate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'Origin':
                            this.columnShowSets.Origin.IsShow = item.IsShow;
                            this.columnShowSets.Origin.Width = item.Width;
                            this.columnShowSets.Origin.ColumnName = item.ColumnName;
                            break;
                        case 'Quality':
                            this.columnShowSets.Quality.IsShow = item.IsShow;
                            this.columnShowSets.Quality.Width = item.Width;
                            this.columnShowSets.Quality.ColumnName = item.ColumnName;
                            break;
                        case 'Size':
                            this.columnShowSets.Size.IsShow = item.IsShow;
                            this.columnShowSets.Size.Width = item.Width;
                            this.columnShowSets.Size.ColumnName = item.ColumnName;
                            break;
                        case 'Size2':
                            this.columnShowSets.Size2.IsShow = item.IsShow;
                            this.columnShowSets.Size2.Width = item.Width;
                            this.columnShowSets.Size2.ColumnName = item.ColumnName;
                            break;
                        case 'Texture':
                            this.columnShowSets.Texture.IsShow = item.IsShow;
                            this.columnShowSets.Texture.Width = item.Width;
                            this.columnShowSets.Texture.ColumnName = item.ColumnName;
                            break;
                        case 'Color':
                            this.columnShowSets.Color.IsShow = item.IsShow;
                            this.columnShowSets.Color.Width = item.Width;
                            this.columnShowSets.Color.ColumnName = item.ColumnName;
                            break;
                        case 'GoodDesc':
                            this.columnShowSets.GoodDesc.IsShow = item.IsShow;
                            this.columnShowSets.GoodDesc.Width = item.Width;
                            this.columnShowSets.GoodDesc.ColumnName = item.ColumnName;
                            break;
                        case 'UpdateTime':
                            this.columnShowSets.UpdateTime.IsShow = item.IsShow;
                            this.columnShowSets.UpdateTime.Width = item.Width;
                            this.columnShowSets.UpdateTime.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                        case 'PlanPurchase':
                            this.columnShowSets.PlanPurchase.IsShow = item.IsShow;
                            this.columnShowSets.PlanPurchase.Width = item.Width;
                            this.columnShowSets.PlanPurchase.ColumnName = item.ColumnName;
                            break;
                        case 'IntenCount':
                            this.columnShowSets.IntenCount.IsShow = item.IsShow;
                            this.columnShowSets.IntenCount.Width = item.Width;
                            this.columnShowSets.IntenCount.ColumnName = item.ColumnName;
                            break;                           
                    }
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData('SearchAP', true).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'GoodCode':
                            this.searchShowSets.GoodCode.IsShow = item.IsShow;
                            this.searchShowSets.GoodCode.Width = item.Width;
                            this.searchShowSets.GoodCode.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodCode.Title = item.Title;
                            this.searchShowSets.GoodCode.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'BrandId':
                            this.searchShowSets.BrandId.IsShow = item.IsShow;
                            this.searchShowSets.BrandId.Width = item.Width;
                            this.searchShowSets.BrandId.Placeholder = item.Placeholder;
                            this.searchShowSets.BrandId.Title = item.Title;
                            this.searchShowSets.BrandId.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'GoodDesc':
                            this.searchShowSets.GoodDesc.IsShow = item.IsShow;
                            this.searchShowSets.GoodDesc.Width = item.Width;
                            this.searchShowSets.GoodDesc.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodDesc.Title = item.Title;
                            this.searchShowSets.GoodDesc.SortNum = item.SortNum;
                            break;
                        case 'Invent':
                            this.searchShowSets.Invent.IsShow = item.IsShow;
                            this.searchShowSets.Invent.Width = item.Width;
                            this.searchShowSets.Invent.Placeholder = item.Placeholder;
                            this.searchShowSets.Invent.Title = item.Title;
                            this.searchShowSets.Invent.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                        case 'SalesDate':
                            this.searchShowSets.SalesDate.IsShow = item.IsShow;
                            this.searchShowSets.SalesDate.Width = item.Width;
                            this.searchShowSets.SalesDate.Placeholder = item.Placeholder;
                            this.searchShowSets.SalesDate.Title = item.Title;
                            this.searchShowSets.SalesDate.SortNum = item.SortNum;
                            break;
                        case 'Origin':
                            this.searchShowSets.Origin.IsShow = item.IsShow;
                            this.searchShowSets.Origin.Width = item.Width;
                            this.searchShowSets.Origin.Placeholder = item.Placeholder;
                            this.searchShowSets.Origin.Title = item.Title;
                            this.searchShowSets.Origin.SortNum = item.SortNum;
                            break;                            
                    }
                });
                this.isStartSearch = true;
            });
        },
        // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
                this.$refs.dialogTable.doLayout();
            });
        },
        getConfigByCodes() {
            let codes = ['lybsdr', 'ygsfkzdylb'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;

                        }
                    }
                }
            });
        },
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },
        confirmSeriesButton(row) {
            this.searchData.SeriseSelected = [];
            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    item = ele[4];
                }
                this.searchData.SeriseSelected.push(item.AutoSerieId);
            });
            this.dialogVisible = false;
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id && !this.APMsgVisible) {
                this.EntpTempGoodsId = id;
                this.APMsgVisible = true;
            } else {
                this.$refs.APMsg.updateTableData(id);
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    margin-top: 5px;
}

.option-content {
    display: flex;
    line-height: 30px;
}

.searchAp-ctn {
    // height: 615px;
    overflow-y: auto;
}

.search-ctn-left {
    .search-row {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
}

.ops-ctn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 2px;

    .scolor {
        color: #db3737;
    }

    .pcolor {
        color: #0f9960;
    }
}

.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}

/deep/.dialog-search-table-ctn {
    .elx-table {
        .elx-table--body-wrapper {
            padding-bottom: 0px !important;

            .c--tooltip {
                line-height: 32px;
                padding-left: 5px;
            }
        }
    }

    .sp-i {
        margin-left: -6px;
        margin-right: 2px;
    }

    .el-icon-info {
        color: #87a7d6;
        font-size: 18px;
        vertical-align: top;
        margin-top: 1px;
        cursor: pointer;
    }

    .el-icon-picture {
        color: rgb(240, 155, 27);
        font-size: 18px;
        vertical-align: top;
        margin-top: 1px;
        cursor: pointer;
    }
}
</style>
<style lang="less">
.dialog-s-content {

    .dialog-cascader-panel,
    .el-cascader-menu__wrap {
        height: 100%;
    }

    .el-cascader-menu__wrap {
        width: 186px;
    }

    .el-cascader-node__label {
        padding-right: 0;
    }
}

.search-table-i {
    .el-table {
        .el-table__body {
            .current-row {
                >td {
                    background-color: #bbddff;
                }
            }

            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }

        th {
            padding: 4px 0;
        }
    }
}

.searchAp-ctn {
    .el-select {
        .el-select__tags {
            flex-wrap: nowrap;
            overflow: hidden;
        }
    }

    .el-table {
        .el-table__row:hover>td {
            background-color: #dcdee1;
        }
    }
}

#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }

    .add-row-dialog {
        width: 340px;
        height: auto;

        .form-div {
            margin-top: 20px;
        }

        .dialog-footer {
            text-align: right;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

//重新设置层级，不然鼠标移到设置内容过长的单元格时，无法显示内容
.elx-table--tooltip-wrapper {
    z-index: 9999 !important;
}
</style>
